import { Component, Input, OnInit } from '@angular/core';
import { PopoverController } from '@ionic/angular';
import { Meal, Product } from 'src/app/api/contracts/product';

@Component({
  selector: 'app-product-description',
  templateUrl: './product-description.component.html',
  styleUrls: ['./product-description.component.scss'],
})
export class ProductDescriptionComponent implements OnInit {
  @Input() product!: Product;

  toggledItem: ToggleState = 'ingredients';

  constructor(private readonly popoverCtrl: PopoverController) {}

  ngOnInit() {
    return;
  }

  onClose(): void {
    this.popoverCtrl.dismiss();
  }

  onToggle(state: ToggleState): void {
    this.toggledItem = state;
  }
}

type ToggleState = 'ingredients' | 'allergens';
